import React from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from '@99designs/common/i18n/FormattedMessage';
import { DisplayName } from '@99designs/common/components/DisplayName';
import { Avatar } from '@99designs/common/components/Avatar';
import FavoriteButton from 'components/FavoriteButton';
import connectToOnlineStatus from 'components/connectToOnlineStatus';
import TrackClick from './TrackClick';

const ConnectedAvatar = connectToOnlineStatus(Avatar);

export default class DesignAttribution extends React.Component {
    avatar() {
        if (this.canViewOnlineStatus()) {
            return (
                <ConnectedAvatar
                    user={this.avatarUser()}
                    variations={['small']}
                    lastSeenTimesUrl={this.props.design.links.lastSeenTimesUrl}
                />
            );
        }
        return <Avatar user={this.avatarUser()} variations={['small']} />;
    }

    canViewOnlineStatus() {
        return (
            !!this.props.activeUser.id &&
            this.props.activeUser.id !== this.props.design.creator.userId
        );
    }

    userSection() {
        const displayNameVariations = this.props.design.permission.canFavorite
            ? ['offset-right']
            : [];
        return (
            <div className="user user--padded">
                <a className="user__avatar" href={this.props.design.creator.showUrl}>
                    {this.avatar()}
                </a>
                <span className="user__display-name">
                    <TrackClick element="designer_attribution">
                        <FormattedMessage
                            message={__('by {user}')}
                            values={{
                                user: (
                                    <DisplayName
                                        isLinked
                                        user={this.props.design.creator}
                                        variations={displayNameVariations}
                                    />
                                ),
                            }}
                        />
                    </TrackClick>
                    {this.favoriteAbility()}
                </span>
            </div>
        );
    }

    favoriteAbility() {
        if (this.props.design.permission.canFavorite) {
            return (
                <FavoriteButton
                    isFavorite={this.props.design.creator.isFavorite}
                    favoriteUrl={this.props.design.dataFavoriteDesignerUrl}
                    onFavorite={this.props.onFavorite}
                />
            );
        }

        return null;
    }

    categoryInfo() {
        if (this.props.design.categoryEntryInfo) {
            return (
                <a href={this.props.design.links.contestUrl} className="link">
                    {this.props.design.categoryEntryInfo}
                </a>
            );
        }

        return null;
    }

    avatarUser() {
        return {
            avatarUrl: this.props.design.creator.avatarUrl,
            id: this.props.design.creator.userId,
        };
    }

    render() {
        return (
            <div className="sidebar-header__sub-heading">
                {this.userSection()}
                {this.categoryInfo()}
            </div>
        );
    }
}

DesignAttribution.propTypes = {
    design: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    activeUser: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    onFavorite: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/js/apps/ddo/components/DesignAttribution.jsx